// material
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
// hooks
import useAuth from 'src/hooks/useAuth';

const LABELS = {
  demo: 'Demo account',
  internal: 'Internal account',
  exempt: 'License-exempt account',
};

// Persistent header marker for accounts excluded from licensing, so
// nobody inside one (including impersonating admins) mistakes it for a
// paying customer account. Styled as a flat status banner: dark border,
// light tinted fill, one color family per exemption type.
export default function LicenseExemptionChip() {
  const theme = useTheme();
  const { user } = useAuth();
  if (!user?.license_exemption) {
    return null;
  }

  const PALETTES = {
    demo: theme.palette.warning,
    internal: theme.palette.info,
    exempt: {
      main: theme.palette.grey[600],
      dark: theme.palette.grey[700],
      darker: theme.palette.grey[800],
    },
  };
  const palette = PALETTES[user.license_exemption] || PALETTES.exempt;
  const label = LABELS[user.license_exemption] || LABELS.exempt;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        height: 30,
        px: 1.25,
        borderRadius: 1,
        border: `1px solid ${alpha(palette.dark, 0.64)}`,
        boxShadow: `inset 0 0 0 0.5px ${alpha(palette.dark, 0.32)}`,
        backgroundColor: alpha(palette.main, 0.08),
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          backgroundColor: palette.main,
          flexShrink: 0,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          letterSpacing: 0.3,
          lineHeight: 1,
          color: palette.darker || palette.dark,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
